export default {"src":"/_next/static/media/existing-process.b50aa6e3.svg","height":348,"width":230};